import "./Hero.scss";

const Hero = () => {
  return (
    <section id="hero" className="section-hero">
      <div className="container-hero">
        <div className="hero-description">
          <div className="hero-title">WELCOME TO</div>
          <p className="hero-subtitle">MITRA PEMASARAN</p>
          <h1 className="hero-text">SUMMARECON TANGERANG</h1>
        </div>
      </div>
    </section>
  );
};

export default Hero;
